import React, { Component } from 'react';
import '../node_modules/react-vis/dist/style.css';
import Router from './Router';
import { setStorage, getStorage } from './infrastructure/storageService';
import { MuiThemeProvider } from '@material-ui/core';
import SessionProvider from './ui/components/SessionProvider';
import { CookiesBanner } from 'sm-react-components';
import { cookiesPolicy } from './infrastructure/routemap';

import * as sm from 'sm-react-components';

const cookiesMessage = (
    <React.Fragment>
    We use cookies to understand how you use our site and to improve your
    experience. To learn more,{' '}
        <a href={cookiesPolicy} target="_blank" rel="noopener noreferrer">
      click here
        </a>
    . By continuing to use our site, you accept our use of cookies, revised
    Privacy Policy and Terms of Use.
    </React.Fragment>
);

class App extends Component {
  state = {
      cookiesAccepted: undefined
  };

  componentDidMount() {
      this.setState({
          cookiesAccepted: getStorage('cookiesAccepted')
      });
  }

  handleCookiesAccept = () => {
      setStorage('cookiesAccepted', true);
      this.setState({
          cookiesAccepted: true
      });
  };

  render() {
      const { cookiesAccepted } = this.state;
      return (
          <MuiThemeProvider theme={sm.theme}>
              <SessionProvider>
                  <Router />
              </SessionProvider>
              {(!cookiesAccepted || cookiesAccepted === 'false') && (
                  <CookiesBanner
                      message={cookiesMessage}
                      acceptAction={this.handleCookiesAccept}
                      moreInfoAction={() => window.open(cookiesPolicy, '_blank')}
                  />
              )}
          </MuiThemeProvider>
      );
  }
}

export default App;
